var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.wrapper,
    on: {
      "click": _vm.handleOpen,
      "mouseleave": _vm.handleBlur,
      "mouseenter": _vm.handleFocus
    }
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "enter-active-class": _vm.theme.fadeEnterActive,
      "enter-class": _vm.theme.fadeEnter,
      "enter-to-class": _vm.theme.fadeEnterTo,
      "leave-active-class": _vm.theme.fadeLeaveActive,
      "leave-class": _vm.theme.fadeLeave,
      "leave-to-class": _vm.theme.fadeLeaveTo
    }
  }, [(_vm.isOpen) ? _c('div', {
    class: _vm.theme.dropdown
  }, [_c('div', {
    class: _vm.theme.dropdownContainer
  }, [_c('v-dropdown-raw', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "select": function($event) {
        _vm.$emit('select', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._t("item", [_vm._v("\n                            " + _vm._s(props.item) + "\n                        ")], {
          item: props.item
        })]
      }
    }])
  })], 1)]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77885cdd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Dropdown/Dropdown.vue
// module id = 521
// module chunks = 0